import _get from "lodash/get";

export default {
  node_env: process.env.NODE_ENV,
  base_url: process.env.BASE_URL,
  app_name: process.env.VUE_APP_NAME,
  app_env: _get(process.env, "VUE_APP_ENV", "production"),
  app_url: process.env.VUE_APP_URL,
  debug: _get(process.env, "VUE_APP_DEBUG", "true") === "true",
  app_api_url: process.env.VUE_APP_API_URL,
  app_api_request_url: process.env.VUE_APP_API_REQUEST_URL,
  // Commercial's frontend origin, used to redirect a commercial-origin user's
  // logout back to commercial's own login instead of residential's.
  commercial_url: _get(
    process.env,
    "VUE_APP_COMMERCIAL_URL",
    "https://commercial.pzse.com"
  ),
  // Shows/hides the "Login with Commercial SSO" button on the login page.
  enable_commercial_sso_login:
    _get(process.env, "VUE_APP_ENABLE_COMMERCIAL_SSO_LOGIN", "false") ===
    "true",
  // Shows/hides the persistent Residential/Commercial switch in the header,
  // independent of the login-page button above.
  enable_commercial_toggle:
    _get(process.env, "VUE_APP_ENABLE_COMMERCIAL_TOGGLE", "true") === "true",
  ray_enabled: _get(process.env, "VUE_APP_RAY_ENABLED", "true") === "true",
  ray_host: process.env.VUE_APP_RAY_HOST,
  ray_port: process.env.VUE_APP_RAY_PORT,
  patch_notes_url: _get(process.env, "VUE_APP_PATCH_NOTES_URL", null),
  app_env_mode: _get(process.env, "VUE_APP_ENV_MODE", "local"),
  sp_parser_enabled:
    _get(process.env, "VUE_APP_SP_PARSER_ENABLED", "true") === "true",
  // Account IDs exempt from the Express add-on's business-hours time lock.
  express_timelock_bypass_companies: _get(
    process.env,
    "VUE_APP_EXPRESS_TIMELOCK_BYPASS_COMPANIES",
    ""
  )
    .split(",")
    .map(id => id.trim())
    .filter(Boolean)
    .map(Number)
    .filter(id => !isNaN(id))
};
